<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="left-box">
				<div style="font-weight: 700;font-size: 16px;display: flex;align-items: center;">
					发布类型
					<el-select style="width: 280px;margin-left: 42px;" size="small" v-model="tState" placeholder="">
						<el-option
						  v-for="item in tList"
						  :key="item.id"
						  :label="item.name"
						  :value="item.id">
						</el-option>
					</el-select>
				</div>
				<template v-if="tState == 0">
					<div style="margin-top: 25px;padding-left: 25px;">
						<el-radio v-model="radio" label="0" style="font-size: 14px;font-weight: 700;">全部产品/服务</el-radio>
						<el-radio v-model="radio" label="1" style="font-size: 14px;font-weight: 700;">单个产品/服务</el-radio>
					</div>
					<div style="height: 100px;">
						<div v-if="radio==1" @click="showfile=true" style="height: 100px;display: flex;align-items: center;font-size: 12px;color: #888888;
						font-weight: 700;padding-left: 50px;cursor: pointer;">
							<div v-if="goodsId" class="d-flex a-center" style="width: 300px;">
								<div style="height: 40px;width: 40px;">
									<img style="width: 40px;height: 40px;" :src="getCurGoods.goods_thumb" />
								</div>
								<div style="font-size: 14px;font-weight: 700;display: flex;align-items: center;
								box-sizing: border-box;padding: 6px 12px;flex: 1;">
								  <div style="height: 40px;flex: 1;font-size: 14px;color: #888888;">
									<span class="text-hide-2">{{getCurGoods.goods_name}}</span>
								  </div>
								</div>
							</div>
							选择产品/服务 <img style="width: 12px;height: 12px;" src="../../assets/order/jiantoujindian@2x.png" />
						</div>
					</div>
					<div style="font-weight: 700;font-size: 16px;">招商区域</div>
					<div style="padding-left: 25px;margin-top: 23px;font-size: 14px;font-weight: 700;">
						<div class="d-flex a-center" style="height: 50px;">
							<el-radio v-model="dqstate" :label="1" style="font-size: 14px;font-weight: 700;">全国</el-radio>
						</div>
						<div class="d-flex a-center" style="height: 50px;">
							<el-radio v-model="dqstate" :label="2" style="font-size: 14px;font-weight: 700;">按省</el-radio>
							<template v-if="dqstate==2">
								<el-select @change="getCity" style="width: 150px;" size="small" v-model="province" placeholder="选择省/直辖市">
									<el-option
									  v-for="item in provinceList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
							</template>
						</div>
						<div class="d-flex a-center" style="height: 50px;">
							<el-radio v-model="dqstate" :label="3" style="font-size: 14px;font-weight: 700;">按市</el-radio>
							<template v-if="dqstate==3">
								<el-select @change="getCity" style="width: 150px;" size="small" v-model="province" placeholder="选择省/直辖市">
									<el-option
									  v-for="item in provinceList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
								<el-select @change="getArea" style="width: 150px;margin-left: auto;" size="small" v-model="city" placeholder="选择市">
									<el-option
									  v-for="item in cityList"
									  :key="item.region_id"
									  :label="item.region_name"
									  :value="item.region_id">
									</el-option>
								</el-select>
							</template>
							
						</div>
						<!-- <div class="d-flex a-center" style="margin-top: 25px;">
							<div>所在地区：</div>
							<el-select size="small" v-model="area" placeholder="请选择">
								<el-option
								  v-for="item in areaList"
								  :key="item.region_id"
								  :label="item.region_name"
								  :value="item.region_id">
								</el-option>
							</el-select>
						</div> -->
					</div>
					<div style="font-weight: 700;font-size: 16px;margin-top: 25px;display: flex;align-items: center;">
						合作方式
						
					</div>
					<div style="padding-left: 25px;display: flex;">
						<div>
							<div v-for="(item,index) in hzType" :key="index" class="d-flex a-center" style="margin-top: 25px;">
								<el-radio v-model="curHzType" :label="item.id" style="font-size: 14px;font-weight: 700;">{{item.name}}</el-radio>
							</div>
							<div style="display: flex;align-items: center;margin-top: 25px;">
								<img @click="centerDialogVisible=true" style="width: 14px;height: 14px;margin-left: auto;cursor: pointer;" src="../../assets/Home/tianjia@2x.png" />
								<div @click="centerDialogVisible=true" style="font-size: 14px;color: #1E69FF;margin-left: 5px;cursor: pointer;">添加其他</div>
								<img @click="editState=!editState" style="width: 14px;height: 14px;margin-left: 15px;cursor: pointer;" src="../../assets/Home/bianji@2x.png" />
								<div @click="editState=!editState" style="font-size: 14px;color: #1E69FF;margin-left: 5px;cursor: pointer;">{{editState?'取消':'编辑'}}</div>
							</div>
						</div>
						<div style="margin-left: 50px;">
							<div v-if="!editState" v-for="(item,index) in hzType1" :key="index" class="d-flex a-center" style="margin-top: 25px;">
								<el-radio v-model="curHzType" :label="item.id" style="font-size: 14px;font-weight: 700;display: flex;align-items: center;">
								{{item.name}}
								</el-radio>
							</div>
							<div v-if="editState" v-for="(item,index) in hzType1" :key="index" @click="product_work_type_del(item)" class="d-flex a-center" 
							style="margin-top: 25px;cursor: pointer;">
								<img style="width: 16x;height: 16px;" src="../../assets/brand_fixtures/sc.png" />
								<div style="margin-left: 5px;">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
					<div style="font-weight: 700;font-size: 16px;margin-top: 22px;">联系方式（选填）</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						姓名：<el-input v-model="contact_name" maxlength="10" style="width: 280px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						电话：<el-input v-model="contact_tel" maxlength="11" style="width: 280px;" size="small" placeholder="请输入"></el-input>
					</div>
				</template>
				<template v-else-if="tState==2">
					<div style="font-weight: 700;font-size: 16px;margin-top: 25px;display: flex;align-items: center;">
						公司信息
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">招聘公司：</span> 
						<el-input disabled v-model="user_info.company_name"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">面试地点：</span> 
						<el-input v-model="zpdata.interview_location"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">工作地点：</span> 
						<el-input v-model="zpdata.work_location"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">联系电话：</span> 
						<el-input v-model="zpdata.contact_tel"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">邮箱：</span> 
						<el-input v-model="zpdata.email"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div style="font-weight: 700;font-size: 16px;margin-top: 25px;display: flex;align-items: center;">
						招聘信息
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">招聘岗位：</span> 
						<el-input v-model="zpdata.positions" style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">薪资待遇：</span> 
						<el-input v-model="zpdata.salary_lower"  style="width: 130px;margin-left: 21px;" size="small" placeholder="请输入">
							<template slot="append">元</template>
						</el-input>
						<div style="width: 10px;height: 2px;background: #888888;margin: 0 5px;"></div>
						<el-input v-model="zpdata.salary_upper" style="width: 130px;" size="small" placeholder="请输入">
							<template slot="append">元</template>
						</el-input>
					</div>
					<div style="display: flex;">
						<div class="d-flex" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
							<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;height: 32px;line-height: 32px;">快捷标签：</span>
							<div style="width: 302px;">
								<el-input v-for="(item,index) in label" :key="index"
								v-model="item.name"  style="width: 280px;margin-left: 21px;margin-bottom: 10px;" size="small" placeholder="例：3-5年工作经验">
									<template  style="" slot="append">
										<span style="cursor: pointer;" @click="delLabel(index)">
											删除
										</span> 
									</template>
								</el-input>
							</div>
						</div>
						<div style="height: 32px;display: flex;align-items: center;margin-top: 25px;">
							<img @click="addLabel" style="width: 18px;height: 18px;margin-left: 10px;cursor: pointer;" src="../../assets/itemStore/tjmr@2x.png" />
						</div>
					</div>
					<div style="display: flex;">
						<div class="d-flex" style="font-size: 14px;font-weight: 700;margin-top: 15px;padding-left: 25px;">
							<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;height: 32px;line-height: 32px;">岗位职责：</span>
							<el-input v-model="zpdata.job_remark" type="textarea" rows="6"
							style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
						</div>
					</div>
					<div style="display: flex;">
						<div class="d-flex" style="font-size: 14px;font-weight: 700;margin-top: 15px;padding-left: 25px;">
							<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;height: 32px;line-height: 32px;">任职资格：</span>
							<el-input v-model="zpdata.take_remark" type="textarea" rows="6"
							style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
						</div>
					</div>
				</template>
				<template v-else-if="tState==1">
					<div style="font-weight: 700;font-size: 16px;margin-top: 25px;display: flex;align-items: center;">
						联系方式
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">联系人：</span> 
						<el-input v-model="gqdata.contacts"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">联系电话：</span> 
						<el-input v-model="gqdata.contact_tel"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					
					<div style="font-weight: 700;font-size: 16px;margin-top: 25px;display: flex;align-items: center;">
						同步商会
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">是否同步：</span> 
						<el-select v-model="gqdata.syn_fcib" style="width: 280px;margin-left: 21px;" size="small" placeholder="请选择">
							<el-option
							  v-for="item in syn_fcibList"
							  :key="item.id"
							  :label="item.name"
							  :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div v-if="gqdata.syn_fcib == 1" class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 80px;">选择商协会：</span> 
						<el-select v-model="gqdata.fcib_ru_id" style="width: 280px;margin-left: 1px;" size="small" placeholder="请选择">
							<el-option
							  v-for="item in fcib_ru_id"
							  :key="item.fcib_ru_id"
							  :label="item.fcib_name"
							  :value="item.fcib_ru_id">
							</el-option>
						</el-select>
					</div>
					<div style="font-weight: 700;font-size: 16px;margin-top: 25px;display: flex;align-items: center;">
						供求信息
					</div>
					<div class="d-flex a-center" style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">供求标题：</span> 
						<el-input v-model="gqdata.supply_title"  style="width: 280px;margin-left: 21px;" size="small" placeholder="请输入"></el-input>
					</div>
					<div class="d-flex " style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">供求封面：</span> 
						<el-upload
						  class="avatar-uploader"
						  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
						  :show-file-list="false"
						  name="file"
						  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
						  :on-success="getImg"
						  accept='.png,.jpeg,.jpg'>
						  <div class="d-flex j-center a-center" 
						  style="flex-wrap: wrap;background: #FFFFFF;border: 1px solid #d0d0d0;border-radius: 4px;margin-left: 21px;">
							  <template v-if="gqdata.supply_cover">
									<img style="width: 150px;height: 100px;" :src="gqdata.supply_cover" />					  
							  </template>
							  <template v-else>
								  <div style="width: 150px;height: 100px;line-height: 100px;">请添加封面</div>
							  </template>
						  </div>
						</el-upload>
					</div>
					<div class="d-flex " style="font-size: 14px;font-weight: 700;margin-top: 25px;padding-left: 25px;">
						<span style="color: #888888;font-size: 12px;font-weight: 500;width: 60px;">供求内容：</span> 
						<div style="width: 320px;height: 550px;border: 1px solid #979797;border-radius: 6px;overflow: hidden;margin-left: 21px;">
							<div style="width: 100%;height: 48px;background: #f5f5f5;" class="d-flex">
								<div @click="txtShow=true" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
									<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wenzi.png" />
									<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">文字</div>
								</div>
								<el-upload style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center"
								  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
								  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
								  :show-file-list="false"
								  :on-success="getLiveDylist"
								  accept='.jpg,.png'>
								  <div style="cursor: pointer;width: 100%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
									<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/tupian@2x.png" />
									<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">图片</div>
								  </div>
								</el-upload>
								<div @click="upFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
									<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/san.png" />
									<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">上移</div>
								</div>
								<div @click="dowFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
									<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/xiayi@2x.png" />
									<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">下移</div>
								</div>
								<div @click="delfiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
									<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wu.png" />
									<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">删除</div>
								</div>
							</div>
							<div class="txt-box d-flex" style="height: 612px;width: 100%;overflow-y: scroll;flex-wrap: wrap;">
								<div style="width: 100%;">
									<!-- <div style="padding: 3px 6px;font-size: 16px;font-weight: 700;color: #000000;">
										{{title}}
									</div> -->
									<!-- <div v-if="title" style="font-size: 12px;padding: 3px 6px;color: #002451;display: flex;">
										<span>{{user_info.company_name}}</span>
										<span style="margin-left: 15px;color: #888888;">{{getyymmdd()}}</span>
									</div> -->
									<template v-for="(img,imgkey) in dyList">
										<img v-if="img.type == 2" style="width: 365px;box-sizing: border-box;display: block;"
										:style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
										@click="dyIndex = imgkey" :src="img.content" />
										<div @click="dyIndex = imgkey" :style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
										v-else style="padding: 3px 6px;font-size: 15px;color: #666;cursor: pointer;text-indent: 30px;">
											{{img.content}}
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div v-if="tState==0" class="d-flex a-center j-center" style="margin-top: 80px;">
					<div @click="releaseInfo" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
					border-radius: 4px;display: flex;align-items: center;justify-content: center;">
						发布
					</div>
				</div>
				<div v-if="tState==1" class="d-flex a-center j-center" style="margin-top: 80px;">
					<div @click="gq_info_edit" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
					border-radius: 4px;display: flex;align-items: center;justify-content: center;">
						发布供求信息
					</div>
				</div>
				<div v-if="tState==2" class="d-flex a-center j-center" style="margin-top: 80px;">
					<div @click="enterprise_class_info_edit" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
					border-radius: 4px;display: flex;align-items: center;justify-content: center;">
						发布招聘信息
					</div>
				</div>
				
			</div>
			<div class="right-box">
				<div class="message-admin">
					<div style="font-size: 16px;font-weight: 600;cursor: pointer;" @click="setSindex(0)"
					:style="sIndex == 0?'border-bottom: 3px solid #333333;':''">产品/服务</div>
					<div style="font-size: 16px;font-weight: 600;margin-left: 60px;cursor: pointer;" @click="setSindex(1)"
					:style="sIndex == 1?'border-bottom: 3px solid #333333;':''">供求信息</div>
					<div style="font-size: 16px;font-weight: 600;margin-left: 60px;cursor: pointer;" @click="setSindex(2)"
					:style="sIndex == 2?'border-bottom: 3px solid #333333;':''">招聘信息</div>
				</div>
				<div class="message-list-box">
					<div class="message-list">
						<div v-if="sIndex == 0" class="message-item-box d-flex" v-for="(item,index) in megData" :key="index">
							<div class="d-flex a-center" style="flex: 1;padding-bottom: 27px;border-bottom: 1px dashed #BBBBBB;">
								<img style="width: 60px;height: 60px;" :src="item.title_img" />
								<div style="height: 60px;justify-content: space-between;margin-left: 10px;
								flex-direction: column;flex: 1;display: flex;">
									<div style="font-size: 14px;font-weight: 700;">{{user_info.company_name}}</div>
									<div style="font-size: 12px;color: #888;">
									{{item.province_name}}{{item.city_name}}{{item.district_name}}
									| {{item.goods_id==0?'全部商品代理':'部分商品代理'}} | {{item.work_type_name}}
									</div>
									<div style="font-size: 12px;color: #888;">
										{{item.contact_name}} | {{item.contact_tel}}
									</div>
								</div>
							</div>
							<div style="width: 80px;">
								<div @click="leave_message_del(item)" class="d-flex a-center j-center" style="width: 80px;height: 28px;border: 2px solid #BBBBBB;
								border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
									删除
								</div>
							</div>
						</div>
						
						<div v-if="sIndex == 2" class="d-flex" v-for="(item,index) in megData" :key="index" style="margin-top: 20px;">
							<div class="d-flex a-center" style="flex: 1;flex-wrap: wrap;padding-bottom: 27px;border-bottom: 1px dashed #BBBBBB;">
								<!-- <img style="width: 60px;height: 60px;" :src="item.title_img" /> -->
								<div style="width: 100%;">
									<div style="font-size: 14px;font-weight: 700;height: 30px;line-height: 30px;
									display: flex;">
									{{item.positions}}
										<div style="margin-left: auto;font-size: 14px;">{{(item.salary_lower/1000).toFixed(2)}}-{{(item.salary_upper/1000).toFixed(2)}}K</div>
										<div v-if="item.sign_status==0" style="margin-left: auto;font-size: 14px;margin-left: 13px;color: #1E69FF;">审核中</div>
										<div v-if="item.sign_status==2" style="margin-left: auto;font-size: 14px;margin-left: 13px;color: #FF4848;">审核未通过</div>
									</div>
									<div style="display: flex;align-items: center;">
										<div v-for="(v,k) in item.label" style="font-size: 12px;color: #888;height: 30px;line-height: 30px;margin-left: 10rpx;margin-right: 10px;">
											{{v}} {{k==(item.label.length-1)?'':'|'}} 
										</div>
									</div>
									
									<div v-if="item.sign_status!=0" style="font-size: 12px;color: #888; display: flex;align-items: center;width: 100%;">
										<img :src="item.compay_logo" style="width: 16px;height: 16px;margin-right: 6px;" />
										<div>{{item.company_name}}</div>
										<div style="width: 60px;margin-left: auto;">
											<div @click="editEnterprise(item)" class="d-flex a-center j-center" style="width: 60px;height: 26px;border: 2px solid #BBBBBB;
											border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
												编辑
											</div>
										</div>
										<div style="width: 60px;margin-left: 13px;">
											<div @click="enterprise_class_info_del(item,1)" class="d-flex a-center j-center" style="width: 60px;height: 26px;border: 2px solid #BBBBBB;
											border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
												删除
											</div>
										</div>
									</div>
								</div>
								<div v-if="item.sign_status == 2" style="font-size: 12px;font-weight: 600;color: #FF4B4B;width: 100%;">
									{{item.sign_remark}}
								</div>
							</div>
						</div>
						
						<div v-if="sIndex == 1" class="d-flex" style="margin-top: 20px;" v-for="(item,index) in megData" :key="index">
								<div class="d-flex a-center" style="flex: 1;flex-wrap: wrap; padding-bottom: 27px;border-bottom: 1px dashed #BBBBBB;">
									
									<img style="width: 94px;height: 64px;" :src="item.supply_cover" />
									<div style="height: 60px;justify-content: space-between;margin-left: 10px;
									flex-direction: column;flex: 1;display: flex;">
										<div style="font-size: 14px;font-weight: 700;display: flex;width: 100%;">
											{{item.supply_title}}
											<div v-if="item.sign_status==0" style="margin-left: auto;font-size: 14px;color: #1E69FF;">审核中</div>
											<div v-if="item.sign_status==2" style="margin-left: auto;font-size: 14px;color: #FF4848;">审核未通过</div>
										</div>
										<div v-if="item.supply_content" style="font-size: 12px;color: #888;" class="text-hide">
											{{gettxt(item.supply_content)}}
										</div>
										<div style="font-size: 12px;color: #888; display: flex;align-items: center;width: 100%;">
											{{item.company_name}}
											
										</div>
									</div>
									<div v-if="item.sign_status == 2 && item.sign_remark" style="font-size: 12px;font-weight: 600;color: #FF4B4B;width: 100%;margin-top: 10px;">
										<span style="color: #888888;">审核不通过原因:</span> {{item.sign_remark}}
									</div>
									<div style="display: flex;width: 100%;">
										<div v-if="item.sign_status != 0" style="width: 60px;margin-left: auto;">
											<div @click="editgqinfo(item)" class="d-flex a-center j-center" style="width: 60px;height: 26px;border: 2px solid #BBBBBB;
											border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
												编辑
											</div>
										</div>
										<div style="width: 60px;" :style="item.sign_status == 0?'margin-left: auto;':'margin-left: 13px;'">
											<div @click="enterprise_class_info_del(item,2)" class="d-flex a-center j-center" style="width: 60px;height: 26px;border: 2px solid #BBBBBB;
											border-radius: 4px;font-size: 12px;color: #888;cursor: pointer;">
												删除
											</div>
										</div>
									</div>
								</div>
						</div>
						<div v-if="megData.length==0" class="d-flex j-center" style="padding-top: 200px;">
							<img style="width: 150px;height: 150px;" src="../../assets/Home/zwsj@2x.png" />
						</div>
					</div>
					<div style="height: 77px;" class="d-flex a-center j-center">
						<el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,15]"
							:current-page.sync="currentPage" :page-size="pageSize" layout="sizes,prev, pager, next, total,jumper" :total="total_records">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="选择产品/服务"
		  :visible.sync="showfile"
		  width="1170px"
		  center>
		  <div style="padding: 0 20px 20px 20px;background: #F8F8F8;height: 360px;overflow-y: scroll;">
			  <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
				  <label v-for="(item,index) in goodsList" class="d-flex a-center"
				  style="width: 48%;margin-top: 20px;background: #FFFFFF;border-radius: 3px;">
					  <el-radio v-model="goodsId" :label="item.id" style="display: flex;align-items: center;padding-left: 20px;" >
						  <div style="height: 40px;width: 40px;">
						  	<img style="width: 40px;height: 40px;" :src="item.goods_thumb" />
						  </div>
					  </el-radio>
					  <div style="font-size: 14px;font-weight: 700;display: flex;align-items: center;
					  box-sizing: border-box;padding: 6px 12px;flex: 1;">
						  <div style="height: 40px;flex: 1;font-size: 14px;color: #888888;">
							<span class="text-hide-2">{{item.goods_name}}</span>
						  </div>
					  </div>
				  </label>
			  </div>
		  </div>
		  <div style="display: flex;justify-content: center;margin-top: 30px;">
			  <el-pagination
				@size-change="handleSizeChanges"
				@current-change="handleCurrentChanges"
				:current-page="curPage"
				:page-sizes="[10, 15]"
				:page-size="curSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="goodsTotal">
			  </el-pagination>
		  </div>
		  <div class="d-flex a-center j-center" style="margin-top: 20px;">
				<div @click="showfile=false" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #cccccc;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;">
					取消
				</div>
				<div @click="setGoodsId()" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: 30px;">
					确定
				</div>
		  </div>
		</el-dialog>
		<el-dialog
		  title="添加新的合作方式"
		  :visible.sync="centerDialogVisible"
		  width="730px"
		  center>
		  <div class="d-flex j-center">
			  <div style="width: 652px;height: 300px;">
				  <el-input type="textarea" :autosize="{ minRows: 13, maxRows: 13 }"
				  style="width: 652px;height: 300px;box-sizing: border-box;padding: 12px;color: #bbb;" 
				  placeholder="请输入合作方式类型（一次可输入多个,请用逗号隔开）" v-model="name">
				  </el-input>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="centerDialogVisible = false">取 消</el-button>
		    <el-button  size="small" type="primary" @click="product_work_type_add" >添加</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="提示"
		  :visible.sync="txtShow"
		  width="30%"
		  top="30vh">
		  <input v-model="txt" style="width: 100%;height: 30px;box-sizing: border-box;padding: 0 6px;" placeholder="请输入内容" />
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="txtShow=false" size="small" >取 消</el-button>
		    <el-button @click="setTxt()" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
	</div>

</template>

<script>
	
	export default {

		data() {
			return{
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				dqstate:1,
				centerDialogVisible:false,
				userinfo:'',
				wzList:[],
				currentPage: 1, //初始页
				curPage:1,
				pageSize : 10,
				curSize: 10,
				megData: [],
				total_records : 0,
				goodsTotal:0,
				tempBg:'',
				user_info:'',
				curIndex:1,
				busGoods:[],
				wzList:[],
				partnerse_list:[],
				radio:'0',
				provinceList:[],
				province:'',
				cityList:[],
				city:'',
				areaList:[],
				area:'',
				hzType:[],
				hzType1:[],
				curHzType:'',
				showfile:false,
				goodsList:[],
				goodsId:'',
				getCurGoods:'',
				contact_name:'',
				contact_tel:'',
				user_info:JSON.parse(localStorage.getItem('user_info')),
				name:'',
				editState:false,
				sIndex:0,
				tState:0,
				tList:[
					{id:0,name:'产品服务'},
					{id:1,name:'供求信息'},
					{id:2,name:'招聘信息'}
				],
				zpdata:{
					type_id:1,
					interview_location:'',
					contact_tel:'',
					email:'',
					positions:'',
					salary_lower:'',
					salary_upper:'',
					job_remark:'',
					take_remark:'',
					work_location:''
				},
				gqdata:{
					type_id:2,
					contacts:'',
					contact_tel:'',
					syn_fcib:0,
					fcib_ru_id:'',
					supply_title:'',
					supply_cover:''
				},
				supply_content:[],
				fcib_ru_id:[],
				label:[{
					name:''
				}
				],
				syn_fcibList:[
					{id:0,name:'不同步提交到商协会'},
					{id:1,name:'同步提交到商协会'}
				],
				txtShow:false,
				dyList:[],
				imgindex:'',
				dyIndex:'',
				txt:'',
			}
		},
		methods:{
			gettxt(item){
				let str = ''
				item.forEach((v)=>{
					if(v.type == 1 && !str){
						str = v.content
					}
				})
				return str
			},
			setTxt(){
				this.dyList.push({type:1,content:this.txt})
				this.txt = ''
				this.txtShow = false
			},
			//上移简介图片
			upFiles(){
				if(this.dyIndex === 0||this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex-1,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex+1,1)
				this.dyIndex--
			},
			//下移简介图片
			dowFiles(){
				if(this.dyIndex === (this.dyList.length-1) || this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex+2,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex++
			},
			//删除简介图片
			delfiles(){
				if(!this.dyList.length){
					return
				}
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex = ''
			},
			getLiveDylist(file, fileList) {
				this.dyList.push({type:2,content:file.data})
			},
			//获取封面
			getImg(res){
				this.gqdata.supply_cover = res.data
			},
			join_fcib_list(){
				let params = {
					act:'join_fcib_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.product_publish_del(params).then((res)=>{
					if(res.code == 0){
						this.fcib_ru_id = res.data
					}
				})
			},
			editgqinfo(item){
				console.log(item);
				let params = {
					act:'class_info_view',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.product_publish_del(params).then((res)=>{
					this.tState = 1
					this.gqdata = res.data
					this.dyList = res.data.supply_content
					this.gqdata.syn_fcib = parseInt(this.gqdata.syn_fcib)
				})
			},
			editEnterprise(item){
				let params = {
					act:'class_info_view',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.product_publish_del(params).then((res)=>{
					this.tState = 2
					let arr = []
					res.data.label.forEach((v)=>{
						arr.push({name:v})
					})
					this.label = arr
					this.zpdata = res.data
					res.data.contact_tel.forEach((v,k)=>{
						if(k==0){
							this.zpdata.contact_tel = v
						}
					})
				})
			},
			delLabel(index){
				this.label.splice(index,1)
			},
			addLabel(){
				this.label.push({name:''})
			},
			enterprise_class_info_del(item,status){
				let params = {
					act:'enterprise_class_info_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.product_publish_del(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.enterprise_class_info_list(status)
				})
			},
			gq_info_edit(){
				if(this.gqdata.contacts == ''){
					this.$message({
						showClose: false,
						message: '联系人不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.gqdata.contact_tel == ''){
					this.$message({
						showClose: false,
						message: '联系电话不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.gqdata.supply_title == ''){
					this.$message({
						showClose: false,
						message: '供求标题不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.gqdata.supply_cover == ''){
					this.$message({
						showClose: false,
						message: '请上传封面',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.gqdata.syn_fcib == 1 && this.gqdata.fcib_ru_id == ''){
					this.$message({
						showClose: false,
						message: '请选择商协会',
						type: 'error',
						offset: 350
					})
					return
				}
				let params = {
					act:'enterprise_class_info_edit',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.gqdata,
					supply_content:this.dyList,
				}
				this.$api.product_work_type_del(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
						this.enterprise_class_info_list(2)
						this.sIndex = 1
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
				
			},
			enterprise_class_info_edit(){
				
				if(this.zpdata.interview_location == ''){
					this.$message({
						showClose: false,
						message: '面试地点不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.zpdata.contact_tel == ''){
					this.$message({
						showClose: false,
						message: '联系电话不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.zpdata.positions == ''){
					this.$message({
						showClose: false,
						message: '招聘岗位不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.zpdata.positions == ''){
					this.$message({
						showClose: false,
						message: '招聘岗位不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.zpdata.salary_lower == ''){
					this.$message({
						showClose: false,
						message: '薪资待遇不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.zpdata.salary_upper == ''){
					this.$message({
						showClose: false,
						message: '薪资待遇不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				
				
				let arr = []
				this.label.forEach((item,index)=>{
					arr.push(item.name)
				})
				let params = {
					act:'enterprise_class_info_edit',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					...this.zpdata,
					label:JSON.stringify(arr),
				}
				this.$api.product_work_type_del(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
						this.enterprise_class_info_list(1)
						this.sIndex = 2
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			setSindex(index){
				this.sIndex = index
				if(this.sIndex == 0){
					this.leave_message_list()
				}
				if(this.sIndex == 1){
					this.enterprise_class_info_list(2)
				}
				if(this.sIndex == 2){
					this.enterprise_class_info_list(1)
				}
			},
			product_work_type_del(item){
				let params = {
					act:'product_work_type_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids:item.id
				}
				this.$api.product_work_type_del(params).then((res)=>{
					if(res.code == 0){
						this.product_work_type()
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			product_work_type_add(){
				
				let arr = this.name.split(',')
				let temparr = []
				arr.forEach((item)=>{
					item.split('，').forEach((v)=>{
						if(v)temparr.push(v)
					})
				})
				let tarr = []
				new Set(temparr).forEach((item)=>{
					tarr.push(item)
				})
				console.log(tarr);
				
				let params = {
					act:'product_work_type_add',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					name: this.name
				}
				this.$api.product_work_type_add(params).then((res)=>{
					if(res.code == 0){
						this.name = ''
						this.centerDialogVisible = false
						this.product_work_type()
						this.$message({
							showClose: false,
							message: '添加成功',
							type: 'success',
							offset: 350
						})
						
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			getLiveFiles(file, fileList) {
			    this.getBase64(file.raw).then((res) => {
					
					let params = {
						act:'upload_store_logo',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						file: res
					}
					
					this.$api.upload_store_logo(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								showClose: false,
								message: '更换成功',
								type: 'success',
								offset: 350
							})
							this.get_company_info()
						}else{
							this.$message({
								showClose: false,
								message: res.msg,
								type: 'error',
								offset: 350
							})
						}
					})
			    })
			},
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					localStorage.setItem('user_info', JSON.stringify(res.data))
					this.user_info = res.data
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.leave_message_list()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.leave_message_list()
			},
			handleSizeChanges(size) {
				this.curSize = size;
				this.enterprise_goods_list()
			},
			handleCurrentChanges(currentPage) {
				this.curPage = currentPage;
				this.enterprise_goods_list()
			},
			enterprise_class_info_list(type_id){
				
				let params = {
					act:'enterprise_class_info_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:this.pageSize,
					page:this.currentPage,
					type_id:type_id
				}
				this.$api.product_publish_list(params).then((res)=>{
					this.megData = []
					this.total_records = 0
					if(res.code == 0){
						this.megData = res.data
						this.total_records = res.total_records
					}
				})
			},
			//获取留言列表
			leave_message_list(){
				
				let params = {
					act:'product_publish_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:this.pageSize,
					page:this.currentPage
				}
				this.$api.product_publish_list(params).then((res)=>{
					this.megData = []
					this.total_records = 0
					if(res.code == 0){
						this.megData = res.data
						this.total_records = res.total_records
					}
				})
			},
			//删除留言
			leave_message_del(item){
				let params = {
					act:'product_publish_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.product_publish_del(params).then((res)=>{
					if(res.code == 0){
						
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.leave_message_list()
				})
			},
			//获取省
			getProvince(){
				this.$api.getProvince({}).then((res)=>{
					if(res.code == 0){
						this.provinceList = res.data
					}
				})
			},
			//获取市区
			getCity(item){
				this.$api.getCity({province_id:item}).then((res)=>{
					this.cityList = res.data
					this.city = ''
					this.area = ''
				})
			},
			//获取区/县
			getArea(item){
				this.$api.getArea({city_id:item}).then((res)=>{
					this.areaList = res.data
					this.area = ''
				})
			},
			//合作方式类型获取
			product_work_type(){
				let params = {
					act:'product_work_type',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				
				this.$api.product_work_type(params).then((res)=>{
					if(res.code == 0){
						this.hzType = []
						this.hzType1 = []
						res.data.forEach((item)=>{
							if(item.attr_id == 0){
								this.hzType.push(item)
							}else{
								this.hzType1.push(item)
							}
						})
					}
				})
			},
			//获取产品列表
			enterprise_goods_list(){
				let params = {
					act:'enterprise_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status:1,
					page:this.curPage,
					size:this.curSize
				}
				
				this.$api.enterprise_goods_list(params).then((res)=>{
					if(res.code == 0){
						this.goodsList = res.data
						this.goodsTotal = res.total_records
					}
				})
			},
			setGoodsId(){
				this.showfile = false
				this.goodsList.forEach((item)=>{
					if(this.goodsId == item.id){
						this.getCurGoods = item
					}
				})
			},
			//发布信息
			releaseInfo(){
				let params = {
					act:'product_publish',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					goods_id:this.radio==0?this.radio:this.getCurGoods.id,
					province:this.dqstate==1?'':this.province,
					city:this.dqstate==3?this.city:'',
					// district:this.area,
					district:'',
					work_type:this.curHzType,
					contact_name:this.contact_name,
					contact_tel:this.contact_tel
				}
				if((this.dqstate == 2 || this.dqstate == 3) && this.province == ''){
					this.$message({
						showClose: false,
						message: '请选择所在省份',
						type: 'error',
						offset: 350
					})
					return
				}
				if(this.dqstate == 3 && this.city == ''){
					this.$message({
						showClose: false,
						message: '请选择所在市区',
						type: 'error',
						offset: 350
					})
					return
				}
				// if(this.area == ''){
				// 	this.$message({
				// 		showClose: false,
				// 		message: '请选择所在地区',
				// 		type: 'error',
				// 		offset: 350
				// 	})
				// 	return
				// }
				if(this.curHzType == ''){
					this.$message({
						showClose: false,
						message: '请选择合作方式',
						type: 'error',
						offset: 350
					})
					return
				}
				// if(this.contact_name == ''){
				// 	this.$message({
				// 		showClose: false,
				// 		message: '请输入姓名',
				// 		type: 'error',
				// 		offset: 350
				// 	})
				// 	return
				// }
				// if(this.contact_tel == ''){
				// 	this.$message({
				// 		showClose: false,
				// 		message: '请输入电话',
				// 		type: 'error',
				// 		offset: 350
				// 	})
				// 	return
				// }
				this.$api.product_publish(params).then((res)=>{
					if(res.code == 0){
						this.province = ''
						this.city = ''
						this.area = ''
						this.curHzType = ''
						this.contact_name = ''
						this.contact_tel = ''
						this.leave_message_list()
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}

		},
		mounted() {
			this.get_company_info()
			this.leave_message_list()
			this.getProvince()
			this.product_work_type()
			this.enterprise_goods_list()
			this.join_fcib_list()
			console.log(this.user_info);
		},
		computed:{
		}
	}
</script>

<style scoped>
	.content-box{
		width: 1170px;
		min-height: 960px;
		border-radius: 6px;
		display: flex;
	}
	.tabbar-box{
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
		border-radius: 0 0 10px 10px;
		padding: 0 13px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.left-box{
		width: 500px;
		background: #FFFFFF;
		box-sizing: border-box;
		padding: 24px 30px;
		border-radius: 6px;
		height: 1350px;
	}
	.right-box{
		margin-left: 20px;
		flex: 1;
		height: 1350px;
	}
	.message-admin{
		width: 100%;
		height: 60px;
		background: #FFFFFF;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 0px 20px;
		display: flex;
		align-items: center;
	}
	.message-list-box{
		width: 100%;
		height: 1270px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
	}
	.message-list{
		height: 1080px;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 0 20px;
	}
	.message-item-box{
		margin-top: 20px;
		height: 87px;
	}
	.img-boxs::-webkit-scrollbar{
		background: #f5f5f5;
		width: 5px;
	}
	.img-boxs::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #CCCCCC;
		width: 5px;
	}
	.text-hide{
		overflow:hidden;
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:1;
	}
	.text-hide-2{
		overflow:hidden; 
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:2;
	}
</style>
